

































import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
// import SwTable from './sw-table.vue'; // only for types
import {
  TableEntry,
  TableColumnRenderFunc,
} from './types';
import { CSSStyleOptions } from '../common-types';

@Component({
  components: {},
})
export default class SwTableExpandSlide extends SwExtendedVue {
  @Prop({ type: Object, required: false })
  entry: TableEntry;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: Function, required: true })
  expandRender: TableColumnRenderFunc;

  @Prop({ type: Number, required: true })
  nestLevel: number;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  expanded: boolean;

  @Prop({ type: Number, default: 100 })
  width: number;

  @Prop({ type: Number, default: 0 })
  indicatorPos: number;

  get innerStyle(): CSSStyleOptions {
    return {
      width: `${this.width - 1}px`, // offset the container border
    };
  }

  get indiStyle(): CSSStyleOptions {
    let top = this.indicatorPos;
    top = top - (13 / 2);
    return { top: `${top}px` };
  }

  /* tslint:disable-next-line */
  render(h: CreateElement): VNode {
    const slideContent = this.expandRender(h, { entry: this.entry, index: this.index });
    const rootNode = (
      <div class={['sw-table-expand-slide']}>
        <div class={['sw-table-expand-slide__indi']} ref="indi" style={this.indiStyle}></div>
        <div class={['sw-table-expand-slide__inner']} style={this.innerStyle}>{slideContent}</div>
      </div>
    );

    return rootNode as VNode;
  }
}
